import React from 'react'
import WizardStepBase from '../base'
import { Link, withRouter } from 'react-router-dom'
import ConstructionTypes from 'app/components/construction_types'
import ConstructionTypePopup from 'app/components/construction_types/popup'
import constants from '../../../constants'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as constructionsActions from '../../../actions/constructions_actions';
import * as orderActions from '../../../actions/order_actions';

class WizardStepOne extends WizardStepBase{
  constructor(props) {
    super(props);
    this.stepNum = 1;
  }

  render() {
    return (
      <div>
        <h1>Выберите конструкцию</h1>
        <ConstructionTypes collection={this.props.constructions_state.collection} />
        <Link onClick={this.stepChange} className='button button-red button-large wizard-next-action-button' to={constants.ROUTES.STEP2}>
          <span>перейти к выбору размеров</span>
        </Link>
        { this.renderConfirm() }
        <ConstructionTypePopup />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    order_state: state.orderState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    constructions_actions: bindActionCreators(constructionsActions, dispatch),
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch, null, {pure: false})(WizardStepOne));



// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/step_1/index.jsx